import { PaginationOptions, PaginatedResult } from 'types/api';
import useSWR, { invalidateStartsWith } from 'hooks/useSWR';
import { useSWRResource } from 'util/resource/useSWRResource';
import { withPagination } from 'apis/utils';
import config from 'config';
import { UserConversation } from './conversationTypes';

export const conversationRequestListKey = (paginationOptions?: PaginationOptions) => {
  if (!paginationOptions) return undefined;
  return withPagination(`${config.COMPANIES_API_URL}/conversations/requests`, paginationOptions);
};

export const reloadConversationRequestList = () => {
  invalidateStartsWith([`${config.COMPANIES_API_URL}/conversations/requests`]);
};

export const useConversationRequestList = (paginationOptions?: PaginationOptions) => {
  const swrResult = useSWR<PaginatedResult<UserConversation>>(
    conversationRequestListKey(paginationOptions),
    undefined,
    {
      revalidateIfStale: true,
    },
  );

  const swrResource = useSWRResource(swrResult);

  return swrResource;
};
